<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFullscreenOn_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M17.767 4.208h9.166c.475 0 .859.384.859.859v9.166a.858.858 0 0 1-1.672.274l-1.577-4.692-4.764 4.764a1.668 1.668 0 0 1-2.358-2.358l4.764-4.764-4.692-1.577a.858.858 0 0 1 .273-1.672M9.815 24.543l4.692 1.577a.858.858 0 0 1-.273 1.672H5.066a.86.86 0 0 1-.859-.859v-9.166c0-.422.304-.78.72-.848a.87.87 0 0 1 .952.574l1.577 4.692 4.764-4.764a1.666 1.666 0 1 1 2.358 2.358z"
        clip-rule="evenodd"
    />
</svg>
